import React from "react";
import { useTranslation } from "react-i18next";
import { FiUser } from "react-icons/fi";
import { RiFileList2Line } from "react-icons/ri";
import { IoMdStarOutline } from "react-icons/io";

const NavStore = ({ onNav }) => {
  const { t } = useTranslation();
  const items = [
    {
      Icon: <FiUser size={21} />,
      Name: t("navStore.ourStory"),
      path: "/about",
    },
    {
      Icon: <RiFileList2Line size={21} />,
      Name: t("navStore.knowYourCraft"),
      path: "/journal",
    },
    {
      Icon: <IoMdStarOutline size={21} />,
      Name: t("navStore.reviews"),
      path: "/reviews",
    },
  ];

  return (
    <>
      <div className="text-[10px] font-[500] tracking-[0.1em] uppercase text-[#707078] px-[16px] pt-[12px] pb-[6px]">
        The store
      </div>
      {items.map((item, i) => (
        <div
          key={i}
          onClick={() => onNav?.(item.path)}
          className="flex items-center gap-[14px] px-[16px] py-[12px] cursor-pointer"
        >
          <span className="w-[26px] grid place-items-center text-[#2C2C2C] flex-none">
            {item.Icon}
          </span>
          <span className="text-[15px] font-[400] text-[#1F212E]">
            {item.Name}
          </span>
        </div>
      ))}
    </>
  );
};
export default NavStore;
